import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { Toaster } from "sonner";

import Landing from "@/pages/Landing";
import Auth from "@/pages/Auth";
import OwnerDashboard from "@/pages/OwnerDashboard";
import ProDashboard from "@/pages/ProDashboard";
import RequestDetail from "@/pages/RequestDetail";
import Admin from "@/pages/Admin";
import Wallet from "@/pages/Wallet";
import PublicProfile from "@/pages/PublicProfile";
import PaymentSuccess from "@/pages/PaymentSuccess";
import MyBoats from "@/pages/MyBoats";
import KYCPage from "@/pages/KYCPage";
import StripeConnect from "@/pages/StripeConnect";
import AuthCallback from "@/pages/AuthCallback";
import Legal from "@/pages/Legal";
import FAQ from "@/pages/FAQ";
import ProOnboarding from "@/pages/ProOnboarding";
import Rankings from "@/pages/Rankings";

function Protected({ children, roles }) {
  const { user, loading } = useAuth();
  if (loading) return <div className="p-20 text-center text-[#5C6B7D]">Cargando...</div>;
  if (!user) return <Navigate to="/login" replace />;
  if (roles && !roles.includes(user.role)) return <Navigate to="/" replace />;
  return children;
}

function AppInner() {
  const location = useLocation();
  // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
  if (location.hash && location.hash.includes("session_id=")) {
    return <AuthCallback />;
  }
  return (
    <Routes>
      <Route path="/" element={<Landing />} />
      <Route path="/login" element={<Auth mode="login" />} />
      <Route path="/register" element={<Auth mode="register" />} />
      <Route path="/owner" element={<Protected roles={["owner"]}><OwnerDashboard /></Protected>} />
      <Route path="/boats" element={<Protected roles={["owner"]}><MyBoats /></Protected>} />
      <Route path="/pro" element={<Protected roles={["professional"]}><ProDashboard /></Protected>} />
      <Route path="/pro/onboarding" element={<Protected roles={["professional"]}><ProOnboarding /></Protected>} />
      <Route path="/wallet" element={<Protected roles={["professional"]}><Wallet /></Protected>} />
      <Route path="/pro/kyc" element={<Protected roles={["professional"]}><KYCPage /></Protected>} />
      <Route path="/pro/connect" element={<Protected roles={["professional"]}><StripeConnect /></Protected>} />
      <Route path="/request/:id" element={<Protected><RequestDetail /></Protected>} />
      <Route path="/payment/success/:id" element={<Protected><PaymentSuccess /></Protected>} />
      <Route path="/pro/profile/:id" element={<PublicProfile />} />
      <Route path="/legal" element={<Legal />} />
      <Route path="/faq" element={<FAQ />} />
      <Route path="/rankings/:service/:province" element={<Rankings />} />
      <Route path="/admin" element={<Protected roles={["admin"]}><Admin /></Protected>} />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

export default function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <AppInner />
          <Toaster position="top-right" richColors />
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}
